import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { AddressTitleService } from 'src/app/Service/AddressTitle/AddressTitle.service';
import { AlertifyService } from 'src/app/Service/Alertify.service';

@Component({
  selector: 'app-AddressLetterCertificate',
  templateUrl: './AddressLetterCertificate.component.html',
  styleUrls: ['./AddressLetterCertificate.component.scss']
})
export class AddressLetterCertificateComponent implements OnInit {
  @Input() inner_Calibration_Detail_Id:number=0


  ngOnChanges(changes: SimpleChanges) {
    this.inner_Calibration_Detail_Id =changes.inner_Calibration_Detail_Id.currentValue
    this.Read_Certificate_Address()
  }

  constructor(
    private AddressTitle_Service:AddressTitleService,
    private Alertify_Service:AlertifyService,
  ) { }

  ngOnInit() {
  }


  Seletected_Certificate_Address:string=""
  DataList_Address:Array<string>=[]
  
  DataList_Name:Array<string>=[]
  Seletected_Certificate_Name:string=""
  Read_Certificate_Address(){
    this.AddressTitle_Service.GetAddressLetter1(this.inner_Calibration_Detail_Id).subscribe(
      data=>{
        this.DataList_Address=data['result']
        this.Seletected_Certificate_Address=data['selected']

        this.DataList_Name=data['customer']
        this.Seletected_Certificate_Name=data['selectedCustomer']
        
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  SubmitAddressLetter(){
    this.AddressTitle_Service.SubmitAddressLetter(this.inner_Calibration_Detail_Id,
      this.Seletected_Certificate_Address,
      this.Seletected_Certificate_Name).subscribe(
      data=>{

        this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")

      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }



}
